import { createSlice } from "@reduxjs/toolkit";
import { deleteQuotationById, fetchQuotationById, fetchQuotationLog, fetchQuotationTrash, fetchTrashQuotationById, revertQuotationById } from "./thunk";

interface QuotationState {
  list: any[];
  trashList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedQuotation: any;
}

const initialState: QuotationState = {
  list: [],
  trashList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedQuotation: null
};

const QuotationSlice = createSlice({
  name: "quotation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Quotation Log
      .addCase(fetchQuotationLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuotationLog.fulfilled, (state, action) => {
        console.log(action)
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchQuotationLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Quotation List";
      })

      // Fetch Quotation Trash
      .addCase(fetchQuotationTrash.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuotationTrash.fulfilled, (state, action) => {
        state.loading = false;
        state.trashList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchQuotationTrash.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Quotation Trash List";
      })

      // Fetch Quotation by ID
      .addCase(fetchQuotationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuotationById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedQuotation = action.payload;
      })
      .addCase(fetchQuotationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })


      // Fetch Trash Quotation
      .addCase(fetchTrashQuotationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrashQuotationById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedQuotation = action.payload;
      })
      .addCase(fetchTrashQuotationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })


      // Delete Quotation By ID
      .addCase(deleteQuotationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteQuotationById.fulfilled, (state, action) => {
        state.loading = false;
        const deletedQuotation = action.payload;
        if (deletedQuotation?.quotation_id) {
          state.list = state.list.filter((quo) => quo.quotation_id !== deletedQuotation.quotation_id);
          state.trashList = state.trashList.filter((quo) => quo.quotation_id !== deletedQuotation.quotation_id);
        } else {
          console.warn('Deleted quotation payload is invalid:', action.payload);
        }
      })
      .addCase(deleteQuotationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Revert Quotation By ID
      .addCase(revertQuotationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(revertQuotationById.fulfilled, (state, action) => {
        state.loading = false;
        const revertedQuotation = action.payload;
        if (revertedQuotation) {
          // Remove from trashList
          state.trashList = state.trashList.filter((quo) => quo.quotation_id !== revertedQuotation.quotation_id);
          // Add to list (if not present) or update
          const existingIndex = state.list.findIndex((quo) => quo.quotation_id === revertedQuotation.quotation_id);
          if (existingIndex !== -1) {
            state.list[existingIndex] = { ...revertedQuotation, status: true, is_deleted: false };
          } else {
            state.list.push({ ...revertedQuotation, status: true, is_deleted: false });
          }
        }
      })
      .addCase(revertQuotationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export default QuotationSlice.reducer;
